import styled from "styled-components";

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
`;

export const LoaderMessage = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;